// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"123":"case","357":"casesFrame","794":"cases","933":"auth"}[chunkId] || chunkId) + "." + {"123":"c06282c5","163":"acaa0fe2","288":"3b960e8a","357":"03c0aa8b","794":"efc8499c","865":"b3e76979","933":"3b503441","986":"88d51c11"}[chunkId] + ".css";
};